import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  private readonly authToken = environment.authToken;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isAbsolute = /^https?:\/\//i.test(request.url);

    const isNonApiAbsolute =
      isAbsolute && !request.url.startsWith(environment.apiUrl);

    let reqToSend = request;

    if (!isNonApiAbsolute) {
      const token = localStorage.getItem(environment.authToken);
      if (token) {
        reqToSend = request.clone({
          setHeaders: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        });
      }
    }

    return next.handle(reqToSend).pipe(
      tap((event) => {
        if (
          event instanceof HttpResponse &&
          !isNonApiAbsolute
        ) {
          const requestAuthHeader = reqToSend.headers.get('authorization');
          const responseAuthHeader = event.headers.get('Authorization');

          if (
            requestAuthHeader &&
            responseAuthHeader &&
            requestAuthHeader !== responseAuthHeader
          ) {
            const newToken = responseAuthHeader.substring(7);
            localStorage.setItem(this.authToken, JSON.stringify(newToken));
          }
        }
      })
    );
  }
}
